<template>
  <div class="baseview">
    <router-view :style="viewStyle"></router-view>
    <div class="loadscreen" v-if="loading">
      <div class="loader"></div>
      <div class="sub-load-text">{{loadText}}</div>
    </div>
    <navigation class="navigation"></navigation>
  </div>
</template>

<script>

import jwt_decode from 'jwt-decode'

import Navigation from './Navigation';

export default {
  name: 'BaseView',
  components: {
    'navigation': Navigation
  },
  data () {
    return {
      loading: false,
      loadText: ''
    }
  },
  methods: {
    verify() {
      try {
        const token = localStorage.getItem('token');

        if (!token) throw new Error('no token found');

        const userId = parseInt(jwt_decode(token).id);

        this.startLoad();

        this.axios.get(this.config.api + '/validate/' + userId, {
          headers: {
            'authorization': token
          }
        }).catch(() => {
          this.logout();
        })
      } catch (error) {
        this.logout();
      }
    },
    logout() {
      this.$router.push('/login')
      localStorage.removeItem('token');
    },
    startLoad(loadText = '') {
      this.loading = true;
      this.loadText = loadText;
    },
    endLoad() {
      this.loading = false;
    }
  },
  computed: {
    viewStyle: function () {
      if (this.loading) return `filter:blur(10px);`
    }
  },
  created() {
    this.global.SetBaseView(this);
    this.verify();
  }
}
</script>

<style scoped>


.navigation {
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 5px;
  width: 100%;
}

.loadscreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  transition: .2s;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loader {
  border: 16px solid rgb(183, 226, 230);
  border-top: 16px solid rgba(102, 36, 130, 1);
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

.sub-load-text {
  margin-top: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.baseview {
  transition: .2s;
}

</style>



// WEBPACK FOOTER //
// src/components/BaseView.vue